module.exports = __webpack_public_path__ + "img/yiguoqi.1b46084a.svg";